/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useMemo } from "react";
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { addNewCustomFabricAtom, fabricAtom, navigatedProductAtom, selectedPartAtom, selectedProductAtom, tabAtom, uploadImageAtom, alankaramDataAtom } from "../../../state";
import Header from "../../../components/Header";
import { Footer } from "antd/es/layout/layout";
import { useLazyQuery } from "@apollo/client";
import { GET_PRODUCT_WITH_PAGINATION_BY_ID } from "../../../apollo/gql/query/products.query";
import Customized from "../Customized";
import { categoryCustomisation } from "../../../lib/categoryWiseCustomisation";

const GLTFImageDetails = () => {

    const getCheckSupport = localStorage.getItem('checkSupport');
    const [, setSelectedProduct] = useRecoilState(selectedProductAtom);
    const { id } = useParams<{ id: string }>();
    const navigate = useNavigate();
    const [fabricAtomState, setFabricsAtomState] = useRecoilState<{ partWiseFabric: any, currentPart: any, currentMaterial: any }>(fabricAtom);
    const alankaramData = useRecoilValue(alankaramDataAtom);
    const [, setAddNewCustomFabric] = useRecoilState(addNewCustomFabricAtom)

    const [, setUploadImage] = useRecoilState(uploadImageAtom);
    const setTabState = useSetRecoilState(tabAtom)
    const [selectedPart, setSelectedPart] = useRecoilState(selectedPartAtom);
    const navigatedProduct = useRecoilValue(navigatedProductAtom)

    

    const initialInput = {
        _id: id,
        companyId: alankaramData?.companyId || "",
    }

    const initialProduct = navigatedProduct ?? null;

    const [fetchProduct, { data }] = useLazyQuery(GET_PRODUCT_WITH_PAGINATION_BY_ID, {
        variables: initialInput,
        fetchPolicy: "cache-and-network",
        onError: (error) => {
            console.log("🚀 ~ error:", error)
            setAddNewCustomFabric([])
            navigate('/products');
        }
    });

    // Fetch product only if not provided in location.state
    useEffect(() => {
        if (!initialProduct) {
            fetchProduct();
        }
    }, [initialProduct, fetchProduct, alankaramData?.companyId]);

    // Safely get productData from location.state OR API response
    const productData = useMemo(() => {
        return initialProduct || data?.getProductStyleDetailById || null;
    }, [initialProduct, data]);

    // Sort parts by Structure first
    const updatedProductData = useMemo(() => {
        if (!productData) return null;
        const partsSorted = Array.isArray(productData.parts)
            ? [...productData.parts].sort((a, b) => {
                if (a.name === "Structure") return -1;
                if (b.name === "Structure") return 1;
                return 0;
            })
            : [];

        return { ...productData, parts: partsSorted };
    }, [productData]);

    useEffect(() => {
        setUploadImage({});
        setAddNewCustomFabric([]);
        setTabState("TAB_1");
    
        if (updatedProductData?.parts?.length > 0) {
            setSelectedPart(updatedProductData.parts[0]);
    
            const matched = categoryCustomisation?.filter((item) =>
                updatedProductData.parts[0]?.materialCategory?.includes(item.parentId)
            );
    
            if (matched?.length > 0 && matched[0]?.name !== fabricAtomState.currentMaterial?.name) {
                console.log('.effect running...');
                setFabricsAtomState((prev) => ({
                    ...prev,
                    currentMaterial: matched[0],
                }));
            }
        }
    }, [id, initialProduct, updatedProductData]);
    

    function support_format_webp() {
        var elem = document.createElement('canvas');

        if (!!(elem.getContext && elem.getContext('2d'))) {
            // was able or not to get WebP representation
            return elem.toDataURL('image/webp').indexOf('data:image/webp') === 0;
        }
        else {
            // very old browser like IE 8, canvas not supported
            return false;
        }
    }
    useEffect(() => {
        if (updatedProductData && id) {
            setFabricsAtomState({
                ...fabricAtomState,
                currentPart: updatedProductData?.parts[0]?.parts || [],
            });
            setSelectedProduct(updatedProductData);
        }
    }, [productData, id]);

    useEffect(() => {
        if (!getCheckSupport) {
            const checkSupport = support_format_webp()
            localStorage.setItem('checkSupport', JSON.stringify(checkSupport))
        }
    }, []);

    return (
        <div className="wrapper">
            <Header />
            <section className="product-info section pt-0">
                <Customized productData={updatedProductData} category={updatedProductData?.category || "pillow"} />
            </section>
            <Footer />
        </div>
    );
}


export default GLTFImageDetails;